<template>
  <BaseButtonDropdown
    v-model="isVisible"
    v-intersection="intersectionConfig"
    :aria-label="$t('chart_setting_action_sheet_widget.toggle_dropdown')"
    close-on-click
    :color="buttonColor"
    data-testid="chart-setting-action-sheet-widget"
    flat
    :icon="dropDown.icon"
    :icon-size="dropDown.size"
    padding="xs"
    placement="bottom-end"
    round
    @hide="onVisibilityChange(false)"
    @show="onVisibilityChange(true)"
  >
    <div
      class="column dropdown-list"
      @click.stop
    >
      <BaseButton
        v-bind="buttonAttrs"
        icon="bin"
        :label="$t('social_integration_row_action_sheet.remove_integration')"
        @click="removeIntegration"
      />
    </div>
  </BaseButtonDropdown>
</template>

<script setup lang="ts">
import type { IntersectionValue } from "quasar";
import { computed, ref } from "vue";
import type { ComponentProps } from "vue-component-type-helpers";

import { BaseButton, BaseButtonDropdown } from "shared/components/base";

interface Dropdown {
  icon: string;
  size: string;
}

interface Props {
  dropDown?: Dropdown;
  buttonColor?: string;
  disable?: boolean;
}

type ButtonAttrs = ComponentProps<typeof BaseButton>;

const props = withDefaults(defineProps<Props>(), {
  dropDown: () => ({
    icon: "more_vert",
    size: "sm",
  }),
  buttonColor: "inherit",
});

const isVisible = ref(false);

const buttonAttrs: ButtonAttrs = {
  newDesign: true,
  newIcon: true,
  actionItem: true,
  iconSize: "md",
  disabled: props.disable,
};

const emit = defineEmits<{
  "remove-integration": [];
}>();

function closeDropdown() {
  isVisible.value = false;
}

const intersectionConfig = computed<IntersectionValue>(() => {
  if (!isVisible.value) {
    return {};
  }

  return {
    handler: (entry?) => {
      if (!entry?.isIntersecting && isVisible.value) {
        closeDropdown();

        return false;
      }

      return true;
    },
  };
});

function onVisibilityChange(newVisible: boolean): void {
  isVisible.value = newVisible;
}

function removeIntegration(): void {
  isVisible.value = false;
  emit("remove-integration");
}
</script>

<style lang="scss" scoped>
.dropdown-list {
  max-height: 400px;
  overflow-y: auto;
  flex-wrap: nowrap;
  border-radius: 5px;
}
</style>
